import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/organisation/")({
    beforeLoad: () => {
        throw redirect({ to: "/admin/organisation/add", replace: true });
    },
});
